import { useState } from "react";
import { ReactComponent as LogoutIcon } from "../../../svgs/logout.svg";
import { Divider } from "@mui/material";
import styles from "./sidebar.module.scss";
import CustomModal from "../../../custom/modal/modal";
import Logout from "../../logout/main";
import useAuth from "../../../hooks/useAuth";
import { sidebarData, sidebarEndData } from "./data";
import SubMenu from "./subMenu";

const ModifiedSidebar = () => {
  const { roles } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const filteredLinks = sidebarData.filter((link) => {
    if (!link.roles) return true;
    return roles?.some((role) => link?.roles?.includes(role.RoleName));
  });

  const filteredEnd = sidebarEndData.filter((link) => {
    if (!link.roles) return true;
    return roles?.some((role) => link?.roles?.includes(role.RoleName));
  });

  return (
    <nav className={styles.nav}>
      <div>
        <div className={styles.logoWrapper}></div>
      </div>

      <div className={styles.menuHeader}>Menu</div>

      {filteredLinks?.map((item, index) => (
        <SubMenu
          key={index}
          subNav={item.subNav}
          roles={item.roles}
          title={item.title}
          icon={item.icon}
          path={item.path}
        />
      ))}

      <Divider />
      
      {filteredEnd?.map((item, index) => (
        <SubMenu
          key={index}
          subNav={item.subNav}
          roles={item.roles}
          title={item.title}
          icon={item.icon}
          path={item.path}
        />
      ))}

      <label className={styles.navLink} onClick={handleOpenModal}>
        <LogoutIcon /> <span>Logout</span>
      </label>

      <CustomModal
        title="Logout"
        maxWidth="xs"
        open={openModal}
        handleClose={handleCloseModal}
        content={<Logout handleClose={handleCloseModal} />}
      />
    </nav>
  );
};

export default ModifiedSidebar;
